import React from "react";
import SearchContainer from "../Form/SearchContainer";
import HomeCard from "../Cards/HomeCard";

const Home = () => {
  return (
    <>
      <SearchContainer />
      <HomeCard />
    </>
  );
};

export default Home;
